import React from 'react';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';

import { postTransactionBatchPurchaseDisapprove } from '../../services/transaction.service';
import { TRANSACTIONS_CONSTANT, PROGRAMS_CONSTANT } from '../../constants/common';
import { includes, values } from 'lodash';

class TransactionBatchPurchaseDisapprove extends React.Component {
  _onClick = async () => {
    const { transaction_batch_id, user_id } = this.props.data;
    const { connect_program_id } = this.props.match.params;
    if (window.confirm('Do you want to disapprove this transaction batch?')) {
      await postTransactionBatchPurchaseDisapprove({
        connect_program_id,
        transaction_batch_id,
        user_id,
      })
        .then((res) => {
          alert(res.message);
          window.location.reload();
        })
        .catch((err) => alert(err.message));
    }
  };

  render() {
    const { transaction_status, transaction_type } = this.props.data;
    const { connect_program_id } = this.props.match.params;
    const medkakiProgramIDList = values(PROGRAMS_CONSTANT.PROGRAM_ID.MEDKAKI);
    const isMedkaki = includes(medkakiProgramIDList, connect_program_id);

    if (isMedkaki) {
      const validStatuses = [TRANSACTIONS_CONSTANT.TRANSACTION_STATUS.PENDING, 
        TRANSACTIONS_CONSTANT.TRANSACTION_STATUS.DISAPPROVED, 
        TRANSACTIONS_CONSTANT.TRANSACTION_STATUS.VOIDED
      ];
  
      return (includes(validStatuses, transaction_status) && transaction_type === TRANSACTIONS_CONSTANT.TRANSACTION_TYPE.PURCHASE) ? (
        <Button variant="contained" onClick={this._onClick} style={{ marginRight: 8 }}>Disapprove</Button>
      ) : null;
    }

    if (includes(connect_program_id, 'pfz-global') || includes(connect_program_id, 'psplink-global')) {
      if (transaction_type === 'application' && transaction_status !== TRANSACTIONS_CONSTANT.TRANSACTION_STATUS.PENDING) {
        return null;
      }
    }
    
    return (
      <Button variant="contained" onClick={this._onClick} style={{ marginRight: 8 }}>Disapprove</Button>
    );
  }
}
export default withRouter(TransactionBatchPurchaseDisapprove);
